module.exports = __webpack_public_path__ + "static/media/997709.3c10fa3c.jpg";